import { render } from "./TargetEvent.vue?vue&type=template&id=39a304bf"
import script from "./TargetEvent.vue?vue&type=script&lang=js"
export * from "./TargetEvent.vue?vue&type=script&lang=js"

import "./TargetEvent.vue?vue&type=style&index=0&id=39a304bf&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__